import { Suspense } from 'react';
import LoadingScreen from '../components/LoadingScreen';

export const Loadable = (Component) => (props) => (
  <Suspense fallback={<LoadingScreen />}>
    <Component {...props} />
  </Suspense>
);
